import React, { useState, useReducer, useEffect } from "react";
import { useDispatch } from "react-redux";

// Components
import Spinner from "../Components/Spinner";
import ToastError from "../Components/ToastError";
import InputField from "../Components/Forms/InputField";
import ModalSearchChip from "./ModalSearchChip";
import SelectField from "../Components/Forms/SelectField";
import ImportModal from "../Components/Modals/Import-modal";

// Services
import { chipService } from "../../Services/chip.service";
import { storage } from "../../Services/storage.service";
import { toDateTimeISOString } from "../../Services/string.service";
import { importService } from "../../Services/import.service";
import { fileService } from "../../Services/file.service";

// Icons
import { AiOutlineSearch, AiFillSave } from "react-icons/ai";
import { FcSimCardChip } from "react-icons/fc";
import { CgImport } from "react-icons/cg";

// Constants
import { storageKeys } from "../../Constants/storage.key";

const _pageTitle = "Cadastro de Chips";
const _registerTitle = "Cadastrando novo Chip";
const _editTitle = "Editando Chip";

const formInitialValues = {
	id: 0,
	licenseeId: 0,
	lineNumber: "",
	iccid: "",
	mobileOperatorId: "",
	statusChip: "",
	privateAPNSince: "",
	isOwn: "true",
};

const formReducer = (state, event) => {
	if (event.setter) {
		return event.chip;
	}
	if (event.reset) {
		return formInitialValues;
	}

	return {
		...state,
		[event.name]: event.value,
	};
};

const filterReducer = (state, event) => {
	if (event.reset) {
		return { lineNumber: "", iccid: "" };
	}
	return {
		...state,
		[event.name]: event.value,
	};
};

const alertReducer = (state, event) => {
	if (event.reset) {
		return { show: false, message: "", color: "danger" };
	}
	return {
		...state,
		show: event.show,
		message: event.message,
		color: event.color,
	};
};

export default function Chips() {
	const [formData, setFormData] = useReducer(formReducer, {});
	const [isLoading, setIsLoading] = useState(false);
	const [showToast, setShowToast] = useState(false);
	const [showSearchModal, setShowSearchModal] = useState(false);
	const [actionTitle, setActionTitle] = useState("Dado do chip");
	const [showFields, setShowFields] = useState(false);
	// eslint-disable-next-line
	const [setShowDelete] = useState(false);
	const [filter, setFilter] = useReducer(filterReducer, {});
	// eslint-disable-next-line
	const [setSelectedChip] = useState({});
	const [listOperators, setListOperators] = useState([]);
	const [listChipStatus, setListChipStatus] = useState([]);
	const [alert, setAlert] = useReducer(alertReducer, {
		show: false,
		message: "",
		color: "danger",
	});
	const [showImportModal, setShowImportModal] = useState(false);

	const [settings] = useState(storage.get(storageKeys.settings));

	const dispatch = useDispatch();

	dispatch({ type: "title", value: _pageTitle });

	const onSearch = () => {
		setAlert({
			reset: true,
		});

		if (filter.lineNumber || filter.iccid) {
			setShowSearchModal(true);
		}
	};

	const onNew = () => {
		setShowDelete(false);
		setAlert({
			reset: true,
		});
		setFormData({
			reset: true,
		});
		setShowFields(true);
		setActionTitle(_registerTitle);
	};

	const onCancel = () => {
		setAlert({
			reset: true,
		});
		setFormData({
			reset: true,
		});
		setShowFields(false);
		setShowDelete(false);
	};

	const onCloseToast = () => {
		setShowToast(false);
	};

	const onSave = async () => {
		if (!formData.lineNumber) {
			setAlert({
				show: true,
				message: "Forneça o Número da Linha!",
				color: "danger",
			});
			return;
		}
		if (!formData.mobileOperatorId) {
			setAlert({
				show: true,
				message: "Forneça a operadora!",
				color: "danger",
			});
			return;
		}
		if (!formData.iccid) {
			setAlert({
				show: true,
				message: "Forneça o ICCID!",
				color: "danger",
			});
			return;
		}
		if (!formData.statusChip) {
			setAlert({ show: true, message: "Forneça o Status", color: "danger" });
			return;
		}

		// Define demais campos
		formData.licenseeId = settings.clientLicensedId;
		formData.privateAPNSince = new Date().toDateISOString();

		console.log(formData);

		try {
			setIsLoading(true);
			var created = await chipService.save(formData);
			setFormData({
				name: "id",
				value: created,
			});
			if (created) {
				setAlert({
					show: true,
					message: "Chip salvo com sucesso!",
					color: "success",
				});
			}
		} catch (error) {
			console.log(error);
			setAlert({
				show: true,
				message: "Não foi possível salvar. tente novamente mais tarde. ",
			});
		} finally {
			setIsLoading(false);
		}
	};

	const handleFilterChange = (event) => {
		setFilter({
			name: event.target.name,
			value: event.target.value.trim(),
		});
	};

	const handleSelectChip = async (chip) => {
		setSelectedChip(chip);

		setFormData({
			chip: chip,
		});

		setShowFields(true);
		setShowSearchModal(false);
		setActionTitle(_editTitle);
		setShowDelete(true);

		// Buscar/usar listas dos selects

		if (listChipStatus.length > 0) {
			var item = listChipStatus.find((x) => x.id === chip.statusChipId);
			setFormData({
				name: "statusChip",
				value: item.id,
			});
		} // eslint-disable-next-line

		if (listChipStatus.length > 0) {
			const item = listOperators.find((x) => x.id === chip.mobileOperatorId);
			setFormData({
				name: "mobileOperatorId",
				value: item.id,
			});
		}

		setFormData({
			name: "id",
			value: chip.id,
		});
		setFormData({
			name: "lineNumber",
			value: chip.numberLine,
		});
		setFormData({
			name: "iccid",
			value: chip.iccid,
		});
	};

	const handleFormChange = async (event) => {
		setFormData({
			name: event.target.name,
			value: event.target.value,
		});
	};

	const handleImport = async (file) => {
		let base64File = await fileService.toBase64(file);
		base64File = base64File.split("base64,")[1];

		var payload = {
			scheduleTypeId: "Chips",
			fileName: file.name,
			fileType: file.type,
			contentType: file.type,
			contentFile: base64File,
			usePeriod: false,
			dateTimeStart: toDateTimeISOString(new Date()),
			dateTimeEnd: toDateTimeISOString(new Date()),
			created: toDateTimeISOString(new Date()),
		};

		await importService.upload(payload);

		setShowImportModal(false);

		setAlert({
			show: true,
			message:
				"Importação do arquivo realizada. <a href='#/imports'>Clique aqui</a> para visualizar status das importações",
			color: "success",
		});
	};

	const handleCloseImport = () => {
		setShowImportModal(false);
	};

	const onImport = () => {
		setShowImportModal(true);
	};

	useEffect(() => {
		(async () => {
			var response_operators = await chipService.listMobileOperator();
			if (response_operators) {
				const withKeys = response_operators.map((item) => {
					return {
						...item,
						key: crypto.randomUUID(),
					};
				});
				setListOperators(withKeys);
			}

			var response_status = await chipService.listChipStatus();
			if (response_status) {
				const withKeys = response_status.map((item) => {
					return {
						...item,
						key: crypto.randomUUID(),
					};
				});
				setListChipStatus(withKeys);
			}
		})();
	}, []);

	return (
		<>
			<div className="container-xxl flex-grow-1 container-p-y">
				{isLoading ? <Spinner /> : ""}

				<ToastError show={showToast} closeToast={onCloseToast} />

				<ModalSearchChip
					show={showSearchModal}
					handleClose={setShowSearchModal}
					filter={filter}
					handleSelect={handleSelectChip}
				/>
				<ImportModal
					title={"Chips"}
					callBackImport={handleImport}
					show={showImportModal}
					handleClose={handleCloseImport}
				/>

				{/* <DeleteModal
          itemName={isDeleting.itemName}
          itemRemoveId={isDeleting.itemRemoveId}
          callBackRemove={handleRemove}
          show={isDeleting.show}
          handleClose={handleCloseModal}
        /> */}

				<div className="row">
					<h5>Preencha os campos para buscar ou crie um novo</h5>
					<div className="row">
						<div className="mb-3 col-md-3">
							<div className="mb-3">
								<div className="input-group">
									<span className="input-group-text text-primary">
										Número da linha
									</span>
									<input
										tabIndex={1}
										type="text"
										className="form-control"
										aria-label="Número da linha"
										placeholder="Número da linha"
										onChange={handleFilterChange}
										aria-describedby="Número da linha"
										name="lineNumber"
									/>
								</div>
							</div>
						</div>
						<div className="mb-3 col-md-3">
							<div className="mb-3">
								<div className="input-group">
									<span className="input-group-text text-primary">ICCID</span>
									<input
										tabIndex={2}
										type="text"
										className="form-control"
										aria-label="iccid"
										aria-describedby="iccid"
										onChange={handleFilterChange}
										name="iccid"
										placeholder="iccid"
									/>
								</div>
							</div>
						</div>

						<div className="mb-3 col-md-4 col-lg-4">
							<div className="d-flex justify-content-around">
								<div>
									<button
										type="button"
										className="btn btn-primary"
										tabIndex={3}
										disabled={showFields}
										onClick={onSearch}
									>
										<AiOutlineSearch className="icon-in-button" />
										Buscar
									</button>
								</div>
								<div>
									<button
										type="button"
										className="btn btn-primary"
										disabled={showFields}
										onClick={onNew}
										tabIndex={4}
									>
										<FcSimCardChip className="icon-in-button" />
										&nbsp; Novo
									</button>
								</div>
								<div>
									<button
										type="button"
										className="btn btn-primary"
										onClick={onImport}
										tabIndex={5}
									>
										<CgImport className="icon-in-button" />
										&nbsp; Importar
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>

				{alert?.show ? (
					<div
						className={`alert alert-${alert.color} alert-dismissible`}
						role="alert"
					>
						<div dangerouslySetInnerHTML={{ __html: alert?.message }}></div>

						<button
							type="button"
							className="btn-close"
							data-bs-dismiss="alert"
							onClick={() => setAlert({ show: false, message: "" })}
							aria-label="Close"
						></button>
					</div>
				) : (
					""
				)}

				<div
					className="row"
					style={showFields ? { display: "" } : { display: "none" }}
				>
					<h4 className="fw-bold py-3 mb-4">
						<span className="text-muted fw-light">{actionTitle} </span>
					</h4>

					{formData.id ? (
						<div className="row mb-1">
							<label className="col-sm-4 col-form-label" htmlFor="licensePlate">
								Id: {formData.id || ""}
							</label>
						</div>
					) : (
						""
					)}

					<div className="col-4">
						<div className="row mb-3">
							<InputField
								label="Número da linha"
								name="lineNumber"
								type="number"
								tabIndex="5"
								grid_length="6"
								value={formData.lineNumber || ""}
								onChange={handleFormChange}
							/>
						</div>

						<div className="row mb-3">
							<SelectField
								name="mobileOperatorId"
								label="Operadora"
								tabIndex="7"
								grid_length="8"
								value={formData.mobileOperatorId || ""}
								itens={listOperators}
								onChange={handleFormChange}
							/>
						</div>
					</div>
					<div className="col-4">
						<div className="row mb-3">
							<InputField
								label="ICCID"
								name="iccid"
								type="number"
								tabIndex="6"
								grid_length="6"
								value={formData.iccid || ""}
								onChange={handleFormChange}
							/>
						</div>

						<div className="row mb-3">
							<SelectField
								name="statusChip"
								label="Status"
								tabIndex="8"
								grid_length="8"
								itens={listChipStatus}
								value={formData.statusChip || ""}
								onChange={handleFormChange}
							/>
						</div>
					</div>

					<div className="mt-4">
						<button
							type="button"
							tabIndex={9}
							className="btn btn-primary me-2"
							onClick={async () => onSave()}
						>
							<AiFillSave className="icon-in-button" />
							&nbsp; Salvar
						</button>

						<button
							type="reset"
							className="btn btn-outline-secondary  me-2"
							onClick={onCancel}
							tabIndex={10}
						>
							Cancelar
						</button>

						{/* <button
              type='button'
              className='btn btn-danger'
              tabIndex={11}
              style={showDelete ? { display: "" } : { display: "none" }}>
              Remover
            </button> */}
					</div>
				</div>
			</div>
		</>
	);
}
